import { ActionType } from 'app/store/actionTypes';
import { ActionsUnion, createAction } from 'app/store/helpers';
import { AcquisitionParamsSetActionPayload } from './actionPayload.interfaces';

export const AcquisitionActions = {
  markQuotationAsRenewal: (isRenewal: boolean) =>
    createAction(ActionType.MARK_QUOTATION_RENEWAL, { isRenewal }),
  changeRenewalOwnersData: (payload: {
    ownerName: string;
    isChanged: boolean;
  }) => createAction(ActionType.CHANGE_RENEWAL_OWNERS_DATA, payload),
  changeRenewalCarData: (payload: { field: string; isChanged: boolean }) =>
    createAction(ActionType.CHANGE_RENEWAL_CAR_DATA, payload),
  setAcquisitionParams: (payload: AcquisitionParamsSetActionPayload) =>
    createAction(ActionType.SET_ACQUISITION_PARAMS, payload),
};

export type AcquisitionActionsType = ActionsUnion<typeof AcquisitionActions>;
